import { useLocalSearchParams } from 'expo-router';

import { ErrorView } from '@/src/components/ErrorView';
import { InternalNotFound } from '@/src/components/InternalNotFound';
import { LoadingView } from '@/src/components/LoadingView';
import { Screen } from '@/src/components/Screen';
import { GarageVehicleForm } from '@/src/features/garage/GarageVehicleForm';
import {
  useGarageVehiclePhotos,
  useRealtimeGarageVehicle,
} from '@/src/features/garage/use-garage';

export default function EditGarageVehicleScreen() {
  const params = useLocalSearchParams<{ vehicleId?: string }>();
  const vehicleId =
    typeof params.vehicleId === 'string' ? params.vehicleId : undefined;
  const vehicleState = useRealtimeGarageVehicle(vehicleId);
  const photoState = useGarageVehiclePhotos(vehicleId);

  if (vehicleState.loading || photoState.loading) {
    return <LoadingView message="Loading vehicle..." />;
  }

  if (vehicleState.error || photoState.error) {
    return (
      <Screen>
        <ErrorView
          message={
            vehicleState.error?.message ??
            photoState.error?.message ??
            'Unable to load this vehicle.'
          }
        />
      </Screen>
    );
  }

  if (!vehicleState.vehicle) {
    return (
      <Screen scroll={false} contentStyle={styles.notFoundContent}>
        <InternalNotFound message="This Garage vehicle may have moved, been deleted, or is no longer available." />
      </Screen>
    );
  }

  return (
    <Screen>
      <GarageVehicleForm
        existingPhotos={photoState.photos}
        vehicle={vehicleState.vehicle}
      />
    </Screen>
  );
}

const styles = {
  notFoundContent: {
    maxWidth: '100%',
    padding: 0,
  },
} as const;
